/* Función que gestiona la apertura del modal con los datos del producto */
async function openProductModal(productId) {
    if (!productId) {
        alert('Producto ID no encontrado');
        return;
    }


    try {
        /* Si el JSON es el mismo que para top_ventas, no tienes que cambiar nada */
        const response = await fetch('/data/productos.json');
        const productos = await response.json();

        const producto = productos.find(p => p.id == productId);

        if (!producto) {
            alert(`No se encontró el producto con ID ${productId}`);
            return;
        }

        /* Rellenamos los campos del modal */
        document.getElementById('product-nombre').innerText = producto.nombre || '';
        document.getElementById('product-categoria').innerText = producto.categoria || '';
        document.getElementById('product-tipo').innerText = producto.tipo || '';
        document.getElementById('product-editorial-familia').innerText = producto.editorial_familia || '';
        document.getElementById('product-cantidad').innerText = producto.cantidad || '';
        document.getElementById('product-precio').innerText = producto.precio || '';
        document.getElementById('product-descuento').innerText = producto.descuento || '';
        document.getElementById('product-fecha-entrada').innerText = producto.fecha_entrada || '';
        document.getElementById('product-fecha-devolucion').innerText = producto.fecha_devolucion || '';

        /* Mostramos el modal con Flowbite */
            const targetEl = document.getElementById('display-inventory-info-modal');
        const modal = new Modal(targetEl);

        modal.show();

        /* Botón de cerrar del modal */
        const closeButton = targetEl.querySelector('.close-modal-inventory-btn');
        closeButton.addEventListener('click', () => modal.hide());

    } catch (error) {
        console.error('Error cargando el detalle del producto:', error);
        alert('Error al cargar los detalles del producto');
    }
}

/* Función para agregar listeners a los elementos clicables por selector */
function addClickListenersToProductNames(selector) {
    const productElements = document.querySelectorAll(selector);

    productElements.forEach(element => {
        element.addEventListener('click', (event) => {
            event.stopPropagation(); // Evitamos que otros eventos interfieran

            const productId = element.getAttribute('data-product-id');
            openProductModal(productId);
        });
    });
}

/* Aplica listeners a ambos listados: */
addClickListenersToProductNames('#articulosnuevos ul li');
addClickListenersToProductNames('#terminal-consulta div[data-product-id]');
addClickListenersToProductNames('#caja a[data-product-id]');